import { LeadInjector, leadInjectorSocialChannel } from "src/app/core/models/lead/lead-injector.model";
import { LeadInjectorDto } from "src/app/infrastructure/lobby-proxy/DTOs/lead-injector.dto";


export function LeadInjectorDtoToLeadInjector(source: LeadInjectorDto): LeadInjector | null {
    if (!source) return null
    return {
        description: source.description,
        note: source.note,
        isEnabled: source.isEnabled,
        isAutoOfferEnabled: source.isAutoOfferingEnabled,
        activationBegin: source.activationBegin ? new Date(source.activationBegin) : null,
        activationEnd: source.activationEnd ? new Date(source.activationEnd) : null,
        id: source.leadInjectorId,
        externalId: source.externalId,
        publicKey: source.publicKey,
        isActive: source.isActive,
        version: source.version,
        created: new Date(source.created),
        updated: new Date(source.updated),
        injectionEndpoint: source.injectionEndpoint,
        socialChannels: source.channels ? source.channels.map(c => c as leadInjectorSocialChannel) : [],
        facebookChannelIds: source.facebookFormConfigurationIds ?? [],
        domains: source.dnsDomainsWhitelist,
        ipAddresses: source.ipAddressesWhitelist

    } as LeadInjector
}